export const PROMPTS = [
  // 動物×シチュエーション（比較して笑う）
  { id: 'an01', text: 'ダンクシュートしている象を描け', type: 'draw', genre: 'animal' },
  { id: 'an02', text: 'スーツを着て出勤するネコを描け', type: 'draw', genre: 'animal' },
  { id: 'an03', text: '恋をしているタコを描け', type: 'draw', genre: 'animal' },
  { id: 'an04', text: '筋トレ中のパンダを描け', type: 'draw', genre: 'animal' },
  { id: 'an05', text: '電話中のゴリラを描け', type: 'draw', genre: 'animal' },
  { id: 'an06', text: '踊っているワニを描け', type: 'draw', genre: 'animal' },
  { id: 'an07', text: '料理しているクマを描け', type: 'draw', genre: 'animal' },
  { id: 'an08', text: '悩んでいるタコを描け', type: 'draw', genre: 'animal' },

  // 被らない系（競争要素）
  { id: 'nc01', text: '他プレイヤーと被らないフルーツを描け', type: 'draw', genre: 'no_clash' },
  { id: 'nc02', text: '他プレイヤーと被らない動物を描け', type: 'draw', genre: 'no_clash' },
  { id: 'nc03', text: '他プレイヤーと被らない職業を描け', type: 'draw', genre: 'no_clash' },
  { id: 'nc04', text: '他プレイヤーと被らない乗り物を描け', type: 'draw', genre: 'no_clash' },
  { id: 'nc05', text: '他プレイヤーと被らないスポーツを描け', type: 'draw', genre: 'no_clash' },

  // バラエティ企画系（30選）
  { id: 'va01', text: '好きなタイプを描け', type: 'draw', genre: 'variety' },
  { id: 'va02', text: '前世の自分を描け', type: 'draw', genre: 'variety' },
  { id: 'va03', text: '10億円当たったら何をするか描け', type: 'draw', genre: 'variety' },
  { id: 'va04', text: '絶対食べたくない料理を描け', type: 'draw', genre: 'variety' },
  { id: 'va05', text: '世界で一番まずそうなラーメンを描け', type: 'draw', genre: 'variety' },
  { id: 'va06', text: '2種類の生物を合体させた新種を描け', type: 'draw', genre: 'variety' },
  { id: 'va07', text: '上司が休日にやってそうなことを描け', type: 'draw', genre: 'variety' },
  { id: 'va08', text: '会社の同僚を動物1匹で表せ', type: 'draw', genre: 'variety' },
  { id: 'va09', text: 'もし総理大臣になったら最初にすることを描け', type: 'draw', genre: 'variety' },
  { id: 'va10', text: '老後の自分を描け', type: 'draw', genre: 'variety' },
  { id: 'va11', text: 'タイムスリップするなら何時代に行くか描け', type: 'draw', genre: 'variety' },
  { id: 'va12', text: '異世界転生したときの職業を描け', type: 'draw', genre: 'variety' },
  { id: 'va13', text: '誰にも言えない趣味を絵で表せ（フィクション可）', type: 'draw', genre: 'variety' },
  { id: 'va14', text: '宝くじ1等当たったら最初に買うものを描け', type: 'draw', genre: 'variety' },
  { id: 'va15', text: '怖い夢に出てきそうなものを描け', type: 'draw', genre: 'variety' },
  { id: 'va16', text: '最後の晩餐に食べたいものを描け', type: 'draw', genre: 'variety' },
  { id: 'va17', text: '隠れた才能を絵で表せ', type: 'draw', genre: 'variety' },
  { id: 'va18', text: '子どもの頃の夢を描け', type: 'draw', genre: 'variety' },
  { id: 'va19', text: '宇宙人に地球を一枚の絵で説明せよ', type: 'draw', genre: 'variety' },
  { id: 'va20', text: 'もし動物になれるなら何になるか描け', type: 'draw', genre: 'variety' },
  { id: 'va21', text: '最強の合体食べ物を描け（2つ合体）', type: 'draw', genre: 'variety' },
  { id: 'va22', text: '逃走中で絶対に捕まらない隠れ場所を描け', type: 'draw', genre: 'variety' },
  { id: 'va23', text: 'ドラえもんの新しい道具を発明して描け', type: 'draw', genre: 'variety' },
  { id: 'va24', text: '自分が主人公の漫画のラスボスを描け', type: 'draw', genre: 'variety' },
  { id: 'va25', text: '100年後の乗り物を描け', type: 'draw', genre: 'variety' },
  { id: 'va26', text: '一番強そうな野菜を描け', type: 'draw', genre: 'variety' },
  { id: 'va27', text: 'ありえない職業の制服を描け', type: 'draw', genre: 'variety' },
  { id: 'va28', text: '上司に怒られた瞬間の顔を描け', type: 'draw', genre: 'variety' },
  { id: 'va29', text: '一番微妙な顔の動物を描け', type: 'draw', genre: 'variety' },
  { id: 'va30', text: '5年後に流行っていそうなものを描け', type: 'draw', genre: 'variety' },
];

export function pickPromptsRandom(count, usedIds = new Set()) {
  const available = PROMPTS.filter((p) => !usedIds.has(p.id));
  const shuffled = [...available].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
